module.exports = __webpack_public_path__ + "img/EditNotificationsOutlined.22b679c8.svg";